import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { msgErro } from '../services/ui';
import { useAuth } from '../contexts/AuthContext';
import SeletorFornecedor from '../components/SeletorFornecedor';
import { fmtDataHora, nomeBonito, Situacao } from './cotacoesUtil';
import './Pedidos.css';
import './Cotacoes.css';

// O que o fornecedor faz com a cotação: preencher (aguardando), revisar (respondida e aberta) ou só ver (encerrada).
const acao = (c) => (!c.aberta ? ['Ver', 'btn-outline-for'] : c.situacao === 'pedido' ? ['Preencher', 'btn-accent-for'] : ['Revisar', 'btn-outline-for']);

// Pedidos de cotação do Centrão; a cotação abre na página própria (/cotacoes/:id — CotacaoDetalhe.js).
export default function Cotacoes() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const multiCnpj = (user?.fornecedores || []).length > 1;
  const [fornSel, setFornSel] = useState('');
  const [lista, setLista] = useState(null);
  const [erro, setErro] = useState('');
  const carregar = useCallback(() => {
    setErro('');
    return api.get('/cotacoes', { params: fornSel ? { fornecedor: fornSel } : {} })
      .then((r) => setLista(r.data)).catch((e) => setErro(msgErro(e, 'Erro ao carregar as cotações.')));
  }, [fornSel]);
  useEffect(() => { setLista(null); carregar(); }, [carregar]);
  const aguardando = (lista || []).filter((c) => c.aberta && c.situacao === 'pedido').length;
  const abrir = (c) => navigate(`/cotacoes/${c.id}`);

  return (
    <div>
      <h4 className="fw-bold mb-1"><i className="bi bi-clipboard-check me-2" style={{ color: 'var(--primary)' }} />Cotações</h4>
      <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
        Pedidos de cotação do Centrão. Abra a cotação, preencha o preço e envie.
      </p>
      <div className="pd-bar"><SeletorFornecedor value={fornSel} onChange={setFornSel} /></div>
      {erro && <div className="alert alert-danger">{erro}</div>}
      {!lista && !erro && <div className="text-center text-muted py-5"><div className="spinner-border spinner-border-sm me-2" />Carregando cotações...</div>}
      {lista && (lista.length === 0 ? (
        <div className="pd-vazio"><i className="bi bi-inbox" />Nenhum pedido de cotação para {multiCnpj && fornSel ? 'este CNPJ' : 'você'} por enquanto.
          <small>Quando o Centrão pedir uma cotação pelo portal, ela aparece aqui e chega um aviso no seu e-mail.</small></div>
      ) : (
        <>
          {aguardando > 0 && <div className="ct-aviso laranja"><i className="bi bi-bell me-1" />{aguardando} cotaç{aguardando === 1 ? 'ão aguardando' : 'ões aguardando'} a sua resposta.</div>}
          <div className="pd-tab-wrap ct-lista">
            <table className="table table-hover table-for pd-tab">
              <thead><tr>
                <th>Cotação</th><th>Pedida em</th><th>Pedida por</th>{multiCnpj && <th>Para</th>}
                <th>Com preço</th><th>Situação</th><th>Última resposta</th><th className="nao-ord" />
              </tr></thead>
              <tbody>
                {lista.map((c) => {
                  const [txt, cls] = acao(c);
                  const pct = c.itens ? Math.round((c.com_preco / c.itens) * 100) : 0;
                  return (
                    <tr key={c.id} onClick={() => abrir(c)} className={c.aberta && c.situacao === 'pedido' ? 'ct-pendente' : ''}>
                      <td data-label="Cotação" className="pd-num">nº {c.cotacao_id}</td>
                      <td data-label="Pedida em">{fmtDataHora(c.pedido_em)}</td>
                      <td data-label="Pedida por">{nomeBonito(c.pedido_nome) || '—'}</td>
                      {multiCnpj && <td data-label="Para"><small>{c.fornecedor_nome}</small></td>}
                      <td data-label="Com preço"><span className="pd-barra"><span style={{ width: `${pct}%` }} /></span>{c.com_preco}<span className="pd-de">/{c.itens}</span></td>
                      <td data-label="Situação"><Situacao c={c} /></td>
                      <td data-label="Última resposta">{c.respondido_em ? <>{fmtDataHora(c.respondido_em)}<small className="pd-cnpj">{c.respondido_nome}{c.respostas > 1 ? ` · ${c.respostas} envios` : ''}</small></> : '—'}</td>
                      <td className="ct-lista-acao"><button type="button" className={`${cls} ct-btn-sm`} onClick={(e) => { e.stopPropagation(); abrir(c); }}>{txt}</button></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      ))}
    </div>
  );
}
